module.exports = __webpack_public_path__ + "static/media/bloquear.124f13fe.svg";